
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flutter-app-development-company",
      function () {
        return require("private-next-pages/flutter-app-development-company.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flutter-app-development-company"])
      });
    }
  